/* One registration and independent row measurements for each comparison table. */
if (!customElements.get('pd-comparison-table')) {
  customElements.define('pd-comparison-table', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.isConnected) this.syncRowHeights();
        });
      };
      this.onResize = (entries) => {
        const width = entries[0].contentRect.width;
        if (width !== this.width) {
          this.width = width;
          this.schedule();
        }
      };
      this.width = null;
      this.observer = new ResizeObserver(this.onResize);
      this.observer.observe(this);
      this.addEventListener('load', this.schedule, true);
      this.addEventListener('swiperAfterInit', this.schedule);
      // The theme's carousel publishes through pubsub, rather than DOM events.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.swiperAfterInit, this.schedule);
      }
      if (document.fonts) document.fonts.ready.then(() => {
        if (this.isConnected) this.schedule();
      });
      this.schedule();
    }
    syncRowHeights() {
      const groups = new Map();
      const rows = this.querySelectorAll('[data-row]');
      rows.forEach((row) => {
        const key = row.dataset.row;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(row);
        row.style.height = 'auto';
        row.style.minHeight = 'auto';
      });
      // Batch reads before writes to avoid layout recalculation for every row.
      const measurements = Array.from(groups.values(), (group) => ({
        group, height: Math.max(...group.map((row) => row.offsetHeight))
      }));
      measurements.forEach(({ group, height }) => {
        if (!height) return;
        group.forEach((row) => {
          row.style.height = `${height}px`;
          row.style.minHeight = `${height}px`;
        });
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.unsubscribe?.();
      this.removeEventListener('load', this.schedule, true);
      this.removeEventListener('swiperAfterInit', this.schedule);
    }
  });
}
